import PersonAddRounded from '@mui/icons-material/PersonAddRounded';
import TSButton from 'components/common/Button/Button';
import StatusBadge from 'components/common/StatusBadge/StatusBadge';
import './ContactChoice.module.scss';

// Picks the Emergency Contact for a walk: each of the walker's contacts as a
// card to tap, then a button to add another. value is the chosen
// EmergencyContactID; onChange(id) answers a tap.
const ContactChoice = ({ contacts, value, onChange, onAdd }) => (
  <div className="flex flex-col gap-2">
    {contacts.length > 0 && (
      <div
        className="ts-contact-choice"
        role="radiogroup"
        aria-label="Emergency Contact"
      >
        {[...contacts]
          .sort((a, b) => a.ContactName.localeCompare(b.ContactName))
          .map((contact) => {
            const id = contact.EmergencyContactID;
            return (
              <label key={id} className="ts-contact-choice__option">
                <input
                  type="radio"
                  name="emergency-contact"
                  value={id}
                  checked={String(value) === String(id)}
                  onChange={() => onChange(id)}
                />
                <span className="ts-contact-choice__dot" aria-hidden="true" />
                <span className="ts-contact-choice__text">
                  <span className="ts-contact-choice__name">
                    {contact.ContactName}
                  </span>
                  <span className="ts-contact-choice__meta">
                    {[contact.Relationship, contact.ContactPhone]
                      .filter(Boolean)
                      .join(' · ')}
                  </span>
                </span>
                {contact.IsPrimary && <StatusBadge status="default" />}
              </label>
            );
          })}
      </div>
    )}
    <div>
      <TSButton
        btnText={contacts.length ? 'Add another contact' : 'Add a contact'}
        btnVariant={contacts.length ? 'text' : 'contained'}
        icon={<PersonAddRounded />}
        onClickFunc={onAdd}
      />
    </div>
  </div>
);

export default ContactChoice;
